var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-0 content",attrs:{"headers":_vm.headers,"items":_vm.variables,"item-key":"id","loading":_vm.loading,"height":"150","dense":"","hide-default-footer":"","single-select":"","fixed-header":""}})}
var staticRenderFns = []

export { render, staticRenderFns }